import { gql } from 'apollo-angular';
import BASIC_DATA_FIELDS from './segments/basic-data-fields';

const GET_RFP_BASIC_DATA = gql`
  query getRfp($rfpId: Long!) {
    rfp(id: $rfpId) {
      ${BASIC_DATA_FIELDS}
    }
  }
`;

export default GET_RFP_BASIC_DATA;
